module.exports = __webpack_public_path__ + "img/hr-brown-hairy-grass-03.084c8fda.png";